import React from 'react';
import { notification, Modal } from 'antd/lib';
import { graphql, compose, withApollo } from 'react-apollo';
import Loading from '../../common/Loading';
import _ from 'lodash';
import moment from 'moment';

import getDeclaracionesJuradas from '../../../graphql/querys/tramites/getDeclaracionesJuradas.graphql';
import deleteDeclaracionJurada from '../../../graphql/mutations/tramites/deleteDeclaracionJurada.graphql';
import getPersonaPorId from '../../../graphql/querys/personas/getPersonaPorId.graphql';

import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';
import getDeclaracionesPorRangoConFiltros from '../../../graphql/querys/tramites/getDeclaracionesPorRangoConFiltros.graphql';
import getCantidadDeclaracionesConFiltros from '../../../graphql/querys/tramites/getCantidadDeclaracionesConFiltros.graphql';

import TablaDeclaracionesJuradas from './TablaDeclaracionesJuradas';
import { descargarCSV } from '../funciones/descargarCSV';

import convertBase64toBlob from '../../common/documentos/convertBase64toBlob';
import ReImprimirNota from '../ReImprimirNota';
import { errorService } from '../../../graphql/utils/utils';

const confirm = Modal.confirm;
@compose(
  graphql(getUsuario),
  graphql(deleteDeclaracionJurada, {
    name: 'deleteDeclaracion',
    options: {
      refetchQueries: [{ query: getDeclaracionesJuradas }],
    },
  })
)
class VerDeclaracionesJuradas extends React.Component {
  constructor(props) {
    super(props);

    let fechaIni = moment()
      .subtract(7, 'd')
      .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
      .toDate();

    let fechaFin = moment()
      .endOf('day')
      .toDate();

    this.state = {
      loading: false,
      filtro: '',
      currentPage: 1,
      listaTotal: [],
      lista: [],
      primeraCarga: true,
      imprimir: false,
      datosImpresion: {},
      filtroNombre: null,
      filtroApellido: null,
      filtroDocumento: null,
      fechaInicio: fechaIni,
      fechaFin: fechaFin,
      pagina: 1,
      cantidadPorPagina: 10,
      cantidadTotal: 0,
      loadingTabla: false,
    };

    this.onDelete = this.onDelete.bind(this);
  }

  componentDidMount() {
    this.getDeclaracionesPorRangoConFiltros();
  }

  getDeclaracionesPorRangoConFiltros = () => {
    this.setState({ loadingTabla: true });
    this.props.client
      .query({
        query: getCantidadDeclaracionesConFiltros,
        variables: {
          fechaInicial: this.state.fechaInicio,
          fechaFinal: this.state.fechaFin,
          filtroNombre: this.state.filtroNombre,
          filtroApellido: this.state.filtroApellido,
          filtroDocumento: this.state.filtroDocumento,
          filtroTipo: this.state.filtroTipo,
        },
      })
      .then(resp => {
        if (
          resp.data.getCantidadDeclaracionesConFiltros ||
          resp.data.getCantidadDeclaracionesConFiltros == 0
        ) {
          this.setState({
            cantidadTotal: resp.data.getCantidadDeclaracionesConFiltros,
          });

          this.props.client
            .query({
              query: getDeclaracionesPorRangoConFiltros,
              variables: {
                fechaInicial: this.state.fechaInicio,
                fechaFinal: this.state.fechaFin,
                filtroNombre: this.state.filtroNombre,
                filtroApellido: this.state.filtroApellido,
                filtroDocumento: this.state.filtroDocumento,
                pagina: this.state.pagina,
                cantidadPorPagina: this.state.cantidadPorPagina,
              },
              fetchPolicy: 'network-only',
            })
            .then(res => {
              this.setState(
                {
                  ...this.state,
                  listaTotal: res.data.getDeclaracionesPorRangoConFiltros,
                  listaOriginal: res.data.getDeclaracionesPorRangoConFiltros,
                  primeraCarga: false,
                  loadingTabla: false,
                },
                function() {
                  this.ordenarLista(
                    this.state.pagina,
                    this.state.cantidadPorPagina
                  );
                }
              );
            })
            .catch(err => {
              console.log('ERROR EN EL DECLARACIONES POR RANGO: ');
              console.log(err);
              errorService(err, {
                fechaInicial: this.state.fechaInicio,
                fechaFinal: this.state.fechaFin,
                filtroNombre: this.state.filtroNombre,
                filtroApellido: this.state.filtroApellido,
                filtroDocumento: this.state.filtroDocumento,
                pagina: this.state.pagina,
                cantidadPorPagina: this.state.cantidadPorPagina,
              });
              Modal.error({
                title: 'Error en la busqueda de declaraciones',
                content:
                  'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
              });
            });
        }
      })
      .catch(err => {
        console.log(
          'ERROR A LA HORA DE OBTENER LA CANTIDAD TOTAL DE DOCUMENTOS'
        );
        console.log('EL ERROR ES: ', err);
        errorService(err, {
          fechaInicial: this.state.fechaInicio,
          fechaFinal: this.state.fechaFin,
          filtroNombre: this.state.filtroNombre,
          filtroApellido: this.state.filtroApellido,
          filtroDocumento: this.state.filtroDocumento,
          filtroTipo: this.state.filtroTipo,
        });
      });
  };

  onDelete(id) {
    //TODO: Hacer el onDelete.
    // console.log("Se desea eliminar la declaracion jurada con id ", id);

    // console.log("USUARIOOOOOOO: ");
    // console.log(this.props.usuario);

    let { usuario } = this.props;

    if (usuario.rol == 'SUPERVISOR' || usuario.rol == 'FUNCIONARIO') {
      let yo = this;
      confirm({
        title:
          'Realmente quiere eliminar esta declaracion jurada y su respectiva venta?',
        content: 'Esta accion no podrá deshacerse',
        onOk() {
          yo.props
            .deleteDeclaracion({
              variables: { _id: id },
            })
            .then(res => {
              // console.log("La respuesta del delete fue....");
              // console.log(res);

              let id = res.data.deleteDeclaracionJurada;

              if (id) {
                yo.eliminarElementoYActualizarLista(id);

                notification.warning({
                  message:
                    'Declaracion Jurada  y su respectiva venta eliminadas',
                  description:
                    'Se ha eliminado la declaracion jurada exitosamente',
                });
              }
            })
            .catch(err => {
              console.log(
                'Existio un error a la hora de eliminar la declaracion jurada'
              );
              console.log(err);
              errorService(err, {
                _id: id,
              });
              Modal.error({
                title: 'Error en la eliminacion de la declaracion jurada',
                content:
                  'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
              });
            });
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    } else {
      Modal.error({
        title:
          'Usted no tiene los permisos necesarios para realizar esta operación',
        content:
          'Para poder realizar esta función, debe tener mas permisos en su cuenta de los que tiene ahora mismo. Por favor, en caso de ser necesario, comuníquese con mesa de ayuda del departamento de informática.',
      });
    }
  }

  eliminarElementoYActualizarLista = idElemento => {
    //Esta funcion esta encargada de eliminar el elemento de la lista, actualizar el estado y re-generar la lista.
    let lTotal = [...this.state.listaTotal];
    let total = this.state.cantidadTotal;

    // eslint-disable-next-line no-unused-vars
    let removidos = _.remove(lTotal, elem => {
      return elem._id == idElemento;
    });
    this.setState(
      {
        ...this.state,
        listaTotal: lTotal,
        cantidadTotal: total - 1,
      },
      function() {
        this.ordenarLista(this.state.pagina, this.state.cantidadPorPagina);
      }
    );
  };

  filtrarPorNombre = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.

    this.setState(
      {
        ...this.state,
        filtroNombre: filtro,
        pagina: 1,
      },
      () => {
        this.getDeclaracionesPorRangoConFiltros();
      }
    );
  };

  filtrarPorApellido = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.

    this.setState(
      {
        ...this.state,
        filtroApellido: filtro,
        pagina: 1,
      },
      () => {
        this.getDeclaracionesPorRangoConFiltros();
      }
    );
  };

  filtrarPorDocumento = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.
    this.setState(
      {
        ...this.state,
        filtroDocumento: filtro,
        pagina: 1,
      },
      () => {
        this.getDeclaracionesPorRangoConFiltros();
      }
    );
  };

  // eslint-disable-next-line no-unused-vars
  onChange = (date, dateString) => {
    this.setState(
      {
        ...this.state,
        fechaInicio: date[0]
          .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          .toDate(),
        fechaFin: date[1]
          .set({ hour: 23, minute: 59, second: 59, millisecond: 0 })
          .toDate(),
      },
      () => {
        this.getDeclaracionesPorRangoConFiltros();
      }
    );
  };

  // eslint-disable-next-line no-unused-vars
  ordenarLista = (numPagina, tamPagina) => {
    let listaOrdenada = _.orderBy(
      this.state.listaTotal,
      [
        declaracion => {
          return declaracion.fecha_creacion;
        },
      ],
      ['desc']
    );

    this.setState({
      ...this.state,
      currentPage: numPagina,
      lista: listaOrdenada,
    });
  };

  onImprimir = registro => {
    this.setState(
      {
        ...this.state,
        loading: true,
      },
      () => {
        this.props.client
          .query({
            query: getPersonaPorId,
            variables: {
              _id: registro.declarante._id,
            },
          })
          .then(respuesta => {
            let persona = respuesta.data.getPersonaPorId;
            let textoOperacion = `Este tramite fue exento del pago de tasa de justicia - Ley N° 1971 Art. 3 -`;
            if (registro && registro.venta) {
              let venta = registro.venta;
              textoOperacion = `Por este trámite se abono la suma de $${venta.importe} mediante el uso de ${venta.tipoPago}, en concepto de pago de tasa de justicia - Ley N° 1971 Art. 3 -`;
            }

            let datosImpresion = {
              ...persona,
              fecha_creacion: new Date(registro.fecha_creacion),
              ...registro,
              numero: registro.numero,
              declaracion_jurada: registro.declaracion,
              fecha_nacimiento: persona.fecha_nacimiento
                ? moment(persona.fecha_nacimiento).toDate()
                : '',
              edad: persona.fecha_nacimiento
                ? Math.floor(
                    moment(new Date()).diff(
                      moment(persona.fecha_nacimiento),
                      'years',
                      true
                    )
                  )
                : '',
              textoOperacion,
            };

            // console.log("Los datos de impresion es....");
            // console.log(datosImpresion);

            this.setState({
              ...this.state,
              loading: false,
              datosImpresion,
              imprimir: true,
            });
          })
          .catch(err => {
            console.log('Error en la obtencion de los datos de la persona');
            console.log(err);
            errorService(err, {
              _id: registro.declarante._id,
            });
          });
      }
    );
  };

  onDescargar = () => {
    // console.log("entre a descargar");
    let data = _.map(this.state.listaTotal, declaracion => {
      return {
        tipo_doc: declaracion.declarante.tipo_doc,
        num_doc: declaracion.declarante.num_doc,
        nombre: declaracion.declarante.nombre,
        apellido: declaracion.declarante.apellido,
        fecha: moment(declaracion.fecha_creacion).format('DD/MM/YYYY'),
        usuario: declaracion.creador
          ? declaracion.creador.apellido.toUpperCase()
          : '-',
      };
    });
    descargarCSV(
      ['Tipo Doc', 'Num Doc', 'Nombre', 'Apellido', 'Fecha', 'Usuario'],
      data,
      `ReporteDeDeclaracionesJuradas-${moment().format('DD/MM/YYYY-HH:mm')}.csv`
    );
  };

  generarRecibo = base64 => {
    const base64PdfBlob = convertBase64toBlob(base64, 'application/pdf');
    const filePdf = URL.createObjectURL(base64PdfBlob);
    window.open(filePdf);
  };

  cambiarPagina = pagina => {
    this.setState(
      {
        pagina: pagina,
      },
      () => {
        this.getDeclaracionesPorRangoConFiltros();
      }
    );
  };

  cambiarTamañoPagina = tamaño => {
    this.setState({
      cantidadPorPagina: tamaño,
    });
  };

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    return (
      <div>
        {!this.state.imprimir && (
          <TablaDeclaracionesJuradas
            declaraciones={this.state.lista}
            history={this.props.history}
            onDelete={this.onDelete}
            filtrarPorNombre={this.filtrarPorNombre}
            filtrarPorApellido={this.filtrarPorApellido}
            filtrarPorDocumento={this.filtrarPorDocumento}
            filtrarPorTipo={this.filtrarPorTipo}
            textoFiltroNombre={this.state.filtroNombre}
            textoFiltroApellido={this.state.filtroApellido}
            textoFiltroDocumento={this.state.filtroDocumento}
            textoFiltroTipo={this.state.filtroTipo}
            onChange={this.onChange}
            imprimir={this.onImprimir}
            onDescargar={this.onDescargar}
            fechaInicio={this.state.fechaInicio}
            fechaFin={this.state.fechaFin}
            pagina={this.state.pagina}
            cambiarPagina={this.cambiarPagina}
            cambiarTamañoPagina={this.cambiarTamañoPagina}
            total={this.state.cantidadTotal}
            cantidadPorPagina={this.state.cantidadPorPagina}
            loadingTabla={this.state.loadingTabla}
            usuario={this.props.usuario}
            generarRecibo={this.generarRecibo}
          />
        )}

        {this.state.imprimir && (
          <ReImprimirNota
            datos={this.state.datosImpresion}
            idModeloNota={this.state.datosImpresion.modelo_nota._id}
            onCancel={() => this.setState({ ...this.state, imprimir: false })}
          />
        )}
      </div>
    );
  }
}

export default withApollo(VerDeclaracionesJuradas);
